export const ERROR_MESSAGE = 'builder.virtual_coach.error_message'
